import styled from 'styled-components';
import { TextButtonMixin } from '../../mixins/components/TextButtonMixin';
export var StyledTextButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledTextButton",
  componentId: "c11n-8-111-1__sc-1nwmfqo-0"
})(["", ""], TextButtonMixin);